export { default as Sidebar } from './component';


// WEBPACK FOOTER //
// ./src/components/mainLayout/sidebar/index.js